import { connect } from 'react-redux';
import { loadWebexUserData } from '../actions/webex';
import WebexSourceManager from '../components/webex_source_manager/webex_source_manager';

function mapStateToProps({ webex }) {
  const { user, teams } = webex;
  return {
    user,
    teams,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadWebexUserData: () => dispatch(loadWebexUserData()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(WebexSourceManager);



// WEBPACK FOOTER //
// ./src/containers/webex_source_manager.js